/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardDto } from '../../models/dashboard-dto';

export interface DashboardsDashboardIdGet$Plain$Params {
  dashboardId: string;
}

export function dashboardsDashboardIdGet$Plain(http: HttpClient, rootUrl: string, params: DashboardsDashboardIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardsDashboardIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('dashboardId', params.dashboardId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DashboardDto>;
    })
  );
}

dashboardsDashboardIdGet$Plain.PATH = '/dashboards/{dashboardId}';
